<template class="bg-gray-100">
  <div class="bg-gray-100 h-full font-poppins">
    <div class="lg:grid  max-lg:flex-col lg:auto-cols-max max-lg:flex lg:grid-cols-3 lg:content-center lg:items-center lg:h-28 border-solid border-stone-100 border-2 drop-shadow-md lg:rounded-sm bg-gray-100 lg:inline-block">
      <div class="lg:flex lg:text-center lg:mb-0 lg:ml-3 lg:col-start-1 lg:absolute lg:left-0 lg:top-3 lg:col-span-2 lg:mx-auto max-lg:mx-auto  lg:mb-8 lg:mx-0 lg:mt-2">
        <a href="https://www.planodesaudesaolucas.com.br/"><img class="lg:w-60 w-72 inline-block" src="../src/assets/logo.png"></a>
        <h1 class="font-poppins text-neutral-900 whitespace-nowrap font-bold tracking-normal lg:inline-block lg:ml-4 max-lg:text-center	text-2xl lg:mt-5 mb-12 max-lg:mt-12 max-lg:mb-12 ">Rede Credenciada</h1>
      </div>
      <div class="lg:col-end-5 text-center lg:mr-3 space-x-4 mb-4 max-lg:flex-col lg:flex">
        <a href="https://www.gov.br/ans/pt-br"><img class="w-40 inline-block" src="../src/assets/logo_ans.gif"></a>
        <a href="https://www.gov.br/ans/pt-br"><img class="w-36 inline-block" src="../src/assets/num_ans.png"></a>
      </div>
    </div>
    
    <div>
      <div v-if="statusLoadingData === false" class="bg-gray-100 lg:h-screen lg:flex lg:justify-center lg:items-center">
        <loadingLogo/>
      </div>
      <div class="lg:flex bg-gray-100">
        <Pesquisa/>
        <router-view/>
        <div class="lg:ml-20 h-full w-full">
          <PlanoInfo/>
          <ResultadoPrestador/>
          <ResultadoProfissionais/>
        </div>
      </div>
    </div>

    <div class="lg:ml-80 pb-4  max-lg:w-[90%] max-lg:mt-6 h-auto max-lg:mt-24">
      <div class="text-neutral font-medium mb-1 text-2xl mb-4"><p>Legenda</p></div>
      <div class="lg:grid space-y-1 lg:mx-auto lg:grid-cols-3">
        <div><img class="h-[25px] inline" src="@/assets/1.png" alt=""><span class="align-middle p-1">Padrão Nacional de Qualidade</span></div> 
        <div><img class="h-[25px] inline" src="@/assets/2.png" alt=""><span class="align-middle p-1">Padrão Internacional de Qualidade</span></div> 
        <div><img class="h-[25px] inline" src="@/assets/3.png" alt=""><span class="align-middle p-1">Padrão Internacional de Qualidade</span></div> 
        <div><img class="h-[25px] inline" src="@/assets/11.png" alt=""><span class="align-middle p-1">Comunicação de Eventos Adversos</span></div> 
        <div><img class="h-[25px] inline" src="@/assets/5.png" alt=""><span class="align-middle p-1">Qualidade Monitorada</span></div> 
        <div><img class="h-[25px] inline" src="@/assets/7.png" alt=""><span class="align-middle p-1">Padrão Nacional de Qualidade</span></div> 
        <div><img class="h-[25px] inline" src="@/assets/8.png" alt=""><span class="align-middle p-1">Padrão Nacional de Qualidade</span></div> 
        <div><img class="h-[25px] inline" src="@/assets/12.png" alt=""><span class="align-middle p-1">Profissional com Residência</span></div> 
        <div><img class="h-[25px] inline" src="@/assets/14.png" alt=""><span class="align-middle p-1">Título de Especialista</span></div>
        <div><img class="h-[25px] inline" src="@/assets/15.png" alt=""><span class="align-middle p-1">Programa de Acreditação</span></div>
        <div><img class="h-[25px] inline" src="@/assets/16.png" alt=""><span class="align-middle p-1">Certificações de Entidades G.O.P.Q.</span></div> 
        <div><img class="h-[25px] inline" src="@/assets/17.png" alt=""><span class="align-middle p-1">Certificação ISO 9001</span></div>
        <div><img class="h-[25px] inline" src="@/assets/13.png" alt=""><span class="align-middle p-1">Profissional com Especialização</span></div>
        <div><img class="h-[25px] inline" src="@/assets/18.png" alt=""><span class="align-middle p-1">Doutorado / Pós-doutorado</span></div>
        <div><img class="h-[25px] inline" src="@/assets/19.png" alt=""><span class="align-middle p-1">Mestrado</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import ResultadoPrestador from './components/ResultadoPrestador.vue';
import Pesquisa from './components/Pesquisa.vue';
import ResultadoProfissionais from './components/ResultadoProfissionais.vue';
import PlanoInfo from './components/planoInfo.vue';
import loadingLogo from './components/loadingLogo.vue';
import { mapState } from "vuex";
import 'vue-select/dist/vue-select.css';

export default {
  computed: {
    ...mapState(['statusLoadingData']),
  },
  components: {
    ResultadoPrestador,
    Pesquisa,
    ResultadoProfissionais,
    PlanoInfo,
    loadingLogo
  }
}
</script>

